import React, { Component } from "react";
import { mapDbTopProduct } from "utils/mappers";
import Button from "screens/components/basic/Button";
import LOOKUP from "constants/lookup";
import GenericTable from "screens/components/advanced/GenericTable";
import { connect } from "react-redux";
import LinearProgress from '@mui/material/LinearProgress';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import { getTopProductsSales } from "actions/DashboardActions";

class topProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      weekActive: false,
      monthActive: true
    }

    this.clickTopProductSalesWeek = this.clickTopProductSalesWeek.bind(this)
    this.clickTopProductSalesMonth = this.clickTopProductSalesMonth.bind(this)
  }

  clickTopProductSalesWeek = () => {
    this.props.handleTopProductSalesFilter('week')
    this.setState({
      weekActive: true,
      monthActive: false
    })
  }

  clickTopProductSalesMonth = () => {
    this.props.handleTopProductSalesFilter('month')
    this.setState({
      weekActive: false,
      monthActive: true
    })
  }

  render() {
    const topProducts = this.props.topProducts;
    return (
      <div id="chart2" className="item col-4-p-0 ml-3">
        <DashDialog 
          text="Top Selling Products"
          link="/report/monthly-sales"
          isReport={true}
          refreshAction={() => this.props.getTopProductsSales({ branchId: this.props.branchId, periodFilter: 'month'})} />
        <div className="products_heigth">
          {this.props.loading ? (
            <LinearProgress />
          ) : (
            <div>
              <div className="list-table-last">
                <GenericTable
                  className="table_center no-header"
                  multiSelectable={false}
                  enableSelectAll={false}
                  selectable={false}
                  stripedRows={true}
                  columns={LOOKUP.product.dashBoardTable}
                  rows={mapDbTopProduct(topProducts)}
                />
              </div>

              <div className="days_btns">
                <Button
                  name="buttonWeek"
                  type="dashboardButton"
                  className={this.state.weekActive ? 'db-btns btn-selected btnNewBrandPOS noPaddingBtn' : 'db-btns btnNewBrandGray noPaddingBtn'}
                  label="Week"
                  onTouchTap={this.clickTopProductSalesWeek}
                />
                <Button
                  name="buttonMonth"
                  type="dashboardButton"
                  className={this.state.monthActive ? 'db-btns btn-selected btn-space btnNewBrandPOS noPaddingBtn' : 'db-btns btn-space btnNewBrandGray noPaddingBtn'}
                  label="Month"
                  onTouchTap={this.clickTopProductSalesMonth}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.common.dbTopProductsCall > 0,
    branchId: state.common.branchId,
  };
}

function mapDispatchToProps(dispatch){
  return {
    getTopProductsSales: (branchId) => dispatch(getTopProductsSales(branchId, true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(topProduct);
